import axios from 'axios';
import analytics from '~/utils/Analytics';
import { Dispatch, createAction } from '@reduxjs/toolkit';

import { GREET_REACTED } from '../Analytics';
import { StateFunction } from '~/types/redux/share';

export const REACTION_CREATED = 'REACTION_CREATED';
export const createdReaction = createAction(REACTION_CREATED);

export const REACTION_CREATE = 'REACTION_CREATE';
export function createReaction() {
  return async (dispatch: Dispatch, getState: StateFunction) => {
    dispatch(createdReaction());

    const state = getState();
    const greet = state.root.model;
    const templateType = state.root.messageTemplate.template_type;

    analytics.track(GREET_REACTED, {
      templateType,
    });

    try {
      await axios.post(`/g/${greet.slug}/reactions`, {
        method: 'POST',
        headers: {
          accept: 'application/json',
        },
        credentials: 'same-origin',
      });
    } catch (e) {
      // do nothing
    }
  };
}
